import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useLocation } from 'react-router-dom';

interface LocationState {
  from?: {
    pathname?: string;
    search?: string;
    hash?: string;
  };
}

const Login: React.FC = () => {
  const { loginWithRedirect } = useAuth0();
  const location = useLocation();

  React.useEffect(() => {
    const state = location.state as LocationState | null;
    const from = state?.from;
    const returnTo = from
      ? `${from.pathname ?? '/'}${from.search ?? ''}${from.hash ?? ''}`
      : '/';

    loginWithRedirect({ appState: { returnTo } });
  }, [loginWithRedirect, location.state]);

  return <div>Loading...</div>;
};

export default Login;
